/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsXmarkMini: {
  name: 'xmark-mini';
  data: string;
} = {
  name: 'xmark-mini',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.707 9.707a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293Z" fill="currentColor"/></svg>`,
};
